import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PartnerConsignmentsTable from './PartnerConsignmentsTable';
const Page = () => {
    return (_jsx("div", { className: "container-fluid", children: _jsxs("article", { className: "article swz-fixed-table-article", children: [_jsx("h2", { className: "article-title", children: "Partner Deliveries" }), _jsx(PartnerConsignmentsTable, {})] }) }));
};
export default Page;
